import React from 'react';
import { Clock, CheckCircle } from 'lucide-react';

const PackageSelection = ({
  packages,
  selectedPackage,
  onSelectPackage,
  onChangePackage,
  error
}) => {
  if (!selectedPackage) {
    return (
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-black mb-6 sm:mb-8">
          Select Your Package
        </h2>
        <div className="space-y-3 sm:space-y-4">
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className="border border-gray-300 rounded-lg p-4 sm:p-6 cursor-pointer hover:border-black transition-colors"
              onClick={() => onSelectPackage(pkg.id)}
            >
              <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-4">
                <div className="flex-1 w-full sm:w-auto">
                  <h3 className="font-bold text-lg sm:text-xl text-black mb-2">
                    {pkg.name}
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
                    {pkg.description}
                  </p>
                  <div className="flex items-center text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
                    <Clock className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-2" />
                    <span className="font-medium">{pkg.duration}</span>
                  </div>
                  {pkg.includes && pkg.includes.length > 0 && (
                    <div className="mb-3 sm:mb-4">
                      <ul className="space-y-1.5 sm:space-y-2">
                        {pkg.includes.slice(0, 3).map((item, idx) => (
                          <li
                            key={idx}
                            className="flex items-center text-xs sm:text-sm text-gray-600"
                          >
                            <CheckCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-2 text-black flex-shrink-0" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="text-left sm:text-right w-full sm:w-auto sm:ml-6">
                  <div className="text-2xl sm:text-3xl font-bold text-black mb-1">
                    ${Number(pkg.price || 0).toFixed(2)}
                  </div>
                  <div className="text-xs text-gray-500">per event</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {error && (
          <p className="mt-6 text-sm text-red-600 text-center font-semibold">
            {error}
          </p>
        )}
        {!error && (
          <p className="mt-6 text-sm text-gray-600 text-center">
            Please select a package to continue
          </p>
        )}
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-black">
          Selected Package
        </h2>
        <button
          onClick={onChangePackage}
          className="text-xs sm:text-sm text-gray-600 hover:text-black transition-colors"
        >
          Change Package
        </button>
      </div>
      <div className="border-2 border-black rounded-lg p-4 sm:p-6 lg:p-8 bg-white">
        <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-4 sm:gap-6 mb-4 sm:mb-6">
          <div className="flex-1 w-full sm:w-auto">
            <h3 className="font-bold text-xl sm:text-2xl mb-2 sm:mb-3 text-black">
              {selectedPackage.name}
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
              {selectedPackage.description}
            </p>
            <div className="flex items-center text-xs sm:text-sm mb-3 sm:mb-4 text-gray-600">
              <Clock className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-2 text-black" />
              <span className="font-medium">{selectedPackage.duration}</span>
            </div>
            {selectedPackage.includes && selectedPackage.includes.length > 0 && (
              <div>
                <h4 className="text-xs sm:text-sm font-semibold mb-2 sm:mb-3 text-black">
                  Included:
                </h4>
                <ul className="space-y-1.5 sm:space-y-2">
                  {selectedPackage.includes.map((item, idx) => (
                    <li
                      key={idx}
                      className="flex items-center text-xs sm:text-sm text-gray-600"
                    >
                      <CheckCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-2 text-black flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <div className="text-left sm:text-right w-full sm:w-auto sm:ml-6">
            <div className="text-3xl sm:text-4xl font-bold mb-1 text-black">
              ${Number(selectedPackage.price || 0).toFixed(2)}
            </div>
            <div className="text-xs text-gray-500">per event</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageSelection;

